import { render, staticRenderFns } from "./WCompanyAdd.vue?vue&type=template&id=5e1a7244&"
import script from "./WCompanyAdd.vue?vue&type=script&lang=ts&"
export * from "./WCompanyAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports